/* ContentBlock - migrated to Tailwind */
export const contentBlockClassName = 'my-[35px] first:mt-0';
